export default __webpack_public_path__ + "static/media/hero-img.31bd9d89.svg";